import { render, staticRenderFns } from "./SenderCmp.vue?vue&type=template&id=655ee18a&scoped=true"
import script from "./SenderCmp.vue?vue&type=script&lang=js"
export * from "./SenderCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655ee18a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655ee18a')) {
      api.createRecord('655ee18a', component.options)
    } else {
      api.reload('655ee18a', component.options)
    }
    module.hot.accept("./SenderCmp.vue?vue&type=template&id=655ee18a&scoped=true", function () {
      api.rerender('655ee18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/serviceOroviderOrder/component/EditCmp/SenderCmp.vue"
export default component.exports